import { initSmoothScroll } from './init-smooth-scroll.js';
import { initRoleCards } from './init-role-cards.js';
import { initRoleFeatures } from './init-role-features.js';
import { initServiceCards } from './init-service-cards.js';
import { initCalculatorReveal } from './init-calculator-reveal.js';
import { initCardTracks } from './init-card-tracks.js';
import { initDemoPopup } from './init-demo-popup.js';
import { initHeaderBurger } from './init-header-burger.js';
import { initHeaderDropdowns } from './init-header-dropdowns.js';
import { initHeaderLanguage } from './init-header-language.js';
import { initSliders } from './slider/index.js';
import { sectionStickyModeInit } from './section-stiky-mode/index.js';
import { initAnimationsInViewport } from './init-animations-in-viewport.js';
import { initBookingSection } from './init-booking-section.js';
import { initBookMonitorSection } from './init-book-monitor-section.js';
import { initTravelControlSection } from './init-travel-control-section.js';
import { initCalculator } from './init-calculator.js';
import { initSavingsCalculatorSection } from './init-savings-calculator-section.js';
import { initRolePlatformSection } from './init-role-platform-section.js';
import { initFaqSection } from './init-faq-section.js';
import { initExtraServicesSection } from './init-advantages-extra-services.js';
import { initAdvantagesSaveTimeSection } from "./init-advantages-save-time.js";
import { initContactsSection } from './init-contacts-section.js';
import { initAdvantagesInfoTrips } from './init-advantages-info-trips.js';

initCardTracks();
initDemoPopup();
initHeaderBurger();
initHeaderDropdowns();
initHeaderLanguage();
initSliders();
initAnimationsInViewport();
initBookingSection();
initBookMonitorSection();
initServiceCards();
initRoleFeatures();
initRoleCards();
initTravelControlSection();
initSavingsCalculatorSection();
initCalculator();
initCalculatorReveal();
initRolePlatformSection();
initFaqSection();
initExtraServicesSection();
initAdvantagesSaveTimeSection();
initAdvantagesInfoTrips();
initContactsSection();


// Режим стики слайда: каждая секция наслаивается на прошлую
const smoothScroll = initSmoothScroll();
sectionStickyModeInit(smoothScroll);
